module.exports = __webpack_public_path__ + "static/icons/icon-caret-down--white-5e21f0e8544b8a96f5a9ab456ee97208.svg";